.cardNumber {
  position: relative;

  &_title {
    position: absolute;
    top: 11px;
    left: 24px;
    z-index: 5;
    color: #7b766f;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.3px;
  }

  &__brandImage {
    position: absolute;
    top: 50%;
    right: 11px;
    transform: translateY(-50%);
    height: 18px;

    &_unknown {
      height: 28px;
    }
  }
}

.cardNumber.empty {
  & div,
  & input {
    padding-top: 26.5px;
  }
}

// :global body.dark {
//   :local {
//     .cardNumber__brandImage {
//       filter: invert(1) grayscale(100%) !important;
//       opacity: 1;
//     }
//   }
// }
